import { useState } from 'react';
import Modal from '../components/Modal';
const API_URL = process.env.REACT_APP_API_URL;

export default function LoginScreen({ onLogin }) {
    const [usuario, setUsuario] = useState('');
    const [password, setPassword] = useState('');
    const [modal, setModal] = useState({ visible: false, titulo: '', mensaje: '', tipo: 'info', onConfirm: null });
    const showModal = (tipo, titulo, mensaje, onConfirm = null) => {
        setModal({ visible: true, tipo, titulo, mensaje, onConfirm });
    };
    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            const res = await fetch(`${API_URL}/auth/login`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                    usuario: usuario.trim(),
                    password,
                }),
            });
            const data = await res.json().catch(() => ({}));
            if (!res.ok) {
                showModal('error', 'Error', data.mensaje || 'No se pudo iniciar sesión');
                return;
            }
            const session = {
                token: data.token,
                debe_cambiar_password: data.debe_cambiar_password,
                user: data.usuario,
            };
            if (!session.token) {
                showModal('error', 'Error', 'Respuesta inválida del servidor (sin token)');
                return;
            }
            onLogin(session);
        } catch (err) {
            showModal('error', 'Error', err.message);
        }
    };

    return (
        <div
            style={{
                minHeight: '100vh',
                display: 'grid',
                placeItems: 'center',
                padding: 24,
                background: '#f3f5f7',
            }}
        >
            <form className="form-container" onSubmit={handleSubmit}>
                <h2 style={{ marginTop: 0, marginBottom: 8, color: '#00928F' }}>
                    Iniciar sesión
                </h2>
                <p style={{ marginTop: 0, marginBottom: 18, color: '#666', fontSize: 14 }}>
                    Ingresa tu usuario y contraseña
                </p>
                <label style={{ display: 'block', fontSize: 13, color: '#444' }}>
                    Usuario
                </label>
                <input
                    className="form-input"
                    value={usuario}
                    onChange={(e) => setUsuario(e.target.value)}
                    placeholder="usuario"
                />
                <label style={{ display: 'block', marginTop: 10, fontSize: 13, color: '#444' }}>
                    Contraseña
                </label>
                <input
                    className="form-input"
                    type="password"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    placeholder="••••••••"
                />
                <button
                    className="formButton"
                    type="submit"
                    style={{ marginTop: 14 }}
                >
                    Entrar
                </button>
            </form>
            <Modal modal={modal} setModal={setModal} />
        </div>
    );
}
